<template>
<div class="physical_tests">
    <v-card>
    <v-toolbar dark flat color="primary">
      <v-toolbar-title>Badanie wydolnościowe</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="!showAdd && (isActiveRunnerTrainer || isActiveRunner)" color="accent" @click="showAdd = true" dark>dodaj badanie</v-btn>
      <v-btn v-if="showAdd" flat small @click="showAdd = false">ukryj</v-btn>
    </v-toolbar>
    </v-card>
    <v-slide-y-transition>
      <v-card class="mt-2" v-if="showAdd">
          <v-layout justify-center row>
            <v-flex sm8 md6 lg5>
              <pulse-zones-form @success="showAdd = false; refresh()"></pulse-zones-form>
            </v-flex>
          </v-layout>

      </v-card>
    </v-slide-y-transition>
    <v-card class="mt-2 pb-1">
      <v-data-iterator
        :items="pulseZonesList"
        :pagination.sync="context"
        :rows-per-page-items="perPageOptions"
        :total-items="rowsTotal"
        :loading="loading"
        content-tag="v-container"
        grid-list-xl
      >
        <v-layout slot="item" slot-scope="props" justify-center row>
        <v-flex
          xs12
          sm10
          md8
          lg6
          xl4
        >
            <pulse-zones v-if="!props.item.edit" :pulse-zones="props.item" @success="refresh()" @remove-pulse-zones="removePulseZones(props.item)"></pulse-zones>
        </v-flex>
        </v-layout>
      </v-data-iterator>
    </v-card>
</div>
</template>

<script>
import {fetchPulseZones, deletePulseZones} from './api'
import {ListMixin} from '@/utils/ListMixin'
import iziToast from 'izitoast'
import { mapState, mapGetters } from 'vuex'
import _ from 'lodash'
import store from '@/store'
import * as types from '@/store/mutation-types'

import PulseZonesForm from './PulseZonesForm'
import PulseZones from './PulseZones'

export default {
  name: 'packages',
  components: {PulseZonesForm, PulseZones},
  mixins: [ListMixin],
  data () {
    return {
      showAdd: false,
      loading: true,
      pulseZonesList: []
    }
  },
  computed: {
    ...mapState(['runner']),
    ...mapGetters(['isActiveRunnerTrainer', 'isActiveRunner'])
  },
  created () {
    this.fetchPulseZonesList()
  },
  watch: {
    '$route': 'fetchPulseZonesList',
    'currentPage': 'fetchPulseZonesList',
    'perPage': function (oldValue, newValue) {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.fetchPulseZonesList()
      }
    }
  },
  methods: {
    refresh: _.debounce(function () {
      this.fetchPulseZonesList()
    }, 400),
    fetchPulseZonesList () {
      let params = this.prepareParams()
      let promise = fetchPulseZones(this.runner, params)
      return promise.then(this.enhanceListData).then((data) => {
        this.loading = false
        this.pulseZonesList = data
        return data
      })
    },
    changePulseZones (item) {
      this.$set(item, 'edit', true)
    },
    removePulseZones (item) {
      this.$root.$confirm('Usuń test', 'Czy na pewno usunąć test?', {confirmText: 'Usuń', color: 'error'}).then((willDelete) => {
        if (willDelete) {
          let promise = deletePulseZones(this.runner, item)
          return promise.then(() => {
            this.refresh()
            store.dispatch(types.RUNNER_REQUEST, [this.runner.id, true])
            iziToast.show({
              message: 'Test został usunięty',
              color: 'green'
            })
          }).catch(() => {
            iziToast.show({
              message: 'Nie udało się usunąć testu.',
              color: 'red'
            })
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/physical_tests/PhysicalTests.vue